import type { BackgroundColor } from "~/common/components/text-icon.style";
import {
  backgroundColors,
  textIconStyle,
} from "~/common/components/text-icon.style";

type TextIconProps = {
  text: string;
  size?: "small" | "large";
};

function getColorFromText(text: string): BackgroundColor {
  if (!text) {
    return backgroundColors[0];
  }
  const colorIndex = text.charCodeAt(0) % backgroundColors.length;

  return backgroundColors[colorIndex];
}

function TextIcon({ text, size }: TextIconProps) {
  const backgroundColor = getColorFromText(text);
  const firstLetter = text.charAt(0);

  return (
    <div
      className={textIconStyle.container({
        background: backgroundColor,
        size,
      })}
    >
      {firstLetter}
    </div>
  );
}

export { TextIcon };
